import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _332ef7c0 = () => interopDefault(import('../pages/company/index.vue' /* webpackChunkName: "pages/company/index" */))
const _6fd22546 = () => interopDefault(import('../pages/datenschutz/index.vue' /* webpackChunkName: "pages/datenschutz/index" */))
const _9de2a9a8 = () => interopDefault(import('../pages/events/index.vue' /* webpackChunkName: "pages/events/index" */))
const _3e32559a = () => interopDefault(import('../pages/impressum/index.vue' /* webpackChunkName: "pages/impressum/index" */))
const _642e84ac = () => interopDefault(import('../pages/imprint/index.vue' /* webpackChunkName: "pages/imprint/index" */))
const _c0a36d24 = () => interopDefault(import('../pages/insights/index.vue' /* webpackChunkName: "pages/insights/index" */))
const _a816e0ac = () => interopDefault(import('../pages/privacy-policy/index.vue' /* webpackChunkName: "pages/privacy-policy/index" */))
const _6482cb9e = () => interopDefault(import('../pages/services/index.vue' /* webpackChunkName: "pages/services/index" */))
const _9382b0e8 = () => interopDefault(import('../pages/technologie/index.vue' /* webpackChunkName: "pages/technologie/index" */))
const _0aa25f5f = () => interopDefault(import('../pages/technology/index.vue' /* webpackChunkName: "pages/technology/index" */))
const _9503f1a0 = () => interopDefault(import('../pages/unternehmen/index.vue' /* webpackChunkName: "pages/unternehmen/index" */))
const _3969e183 = () => interopDefault(import('../pages/company/about-us/index.vue' /* webpackChunkName: "pages/company/about-us/index" */))
const _77538ea3 = () => interopDefault(import('../pages/company/career/index.vue' /* webpackChunkName: "pages/company/career/index" */))
const _114aaef1 = () => interopDefault(import('../pages/company/contact/index.vue' /* webpackChunkName: "pages/company/contact/index" */))
const _e7c73b04 = () => interopDefault(import('../pages/company/events/index.vue' /* webpackChunkName: "pages/company/events/index" */))
const _f040b274 = () => interopDefault(import('../pages/technologie/google-marketing-platform-partner/index.vue' /* webpackChunkName: "pages/technologie/google-marketing-platform-partner/index" */))
const _3097a4e8 = () => interopDefault(import('../pages/technologie/lunio/index.vue' /* webpackChunkName: "pages/technologie/lunio/index" */))
const _5cefa68c = () => interopDefault(import('../pages/technologie/meridian/index.vue' /* webpackChunkName: "pages/technologie/meridian/index" */))
const _8d88ac4e = () => interopDefault(import('../pages/technology/google-marketing-platform-partner/index.vue' /* webpackChunkName: "pages/technology/google-marketing-platform-partner/index" */))
const _c64e1b0a = () => interopDefault(import('../pages/technology/lunio/index.vue' /* webpackChunkName: "pages/technology/lunio/index" */))
const _d62adb72 = () => interopDefault(import('../pages/technology/meridian/index.vue' /* webpackChunkName: "pages/technology/meridian/index" */))
const _43704d6e = () => interopDefault(import('../pages/unternehmen/events/index.vue' /* webpackChunkName: "pages/unternehmen/events/index" */))
const _c7b3a38c = () => interopDefault(import('../pages/unternehmen/karriere/index.vue' /* webpackChunkName: "pages/unternehmen/karriere/index" */))
const _07503d01 = () => interopDefault(import('../pages/unternehmen/kontakt/index.vue' /* webpackChunkName: "pages/unternehmen/kontakt/index" */))
const _61b48b8d = () => interopDefault(import('../pages/unternehmen/ueber-uns/index.vue' /* webpackChunkName: "pages/unternehmen/ueber-uns/index" */))
const _ea74f646 = () => interopDefault(import('../pages/company/events/analytics-hub/index.vue' /* webpackChunkName: "pages/company/events/analytics-hub/index" */))
const _0faedaab = () => interopDefault(import('../pages/company/events/cdp-event/index.vue' /* webpackChunkName: "pages/company/events/cdp-event/index" */))
const _fe33afb8 = () => interopDefault(import('../pages/company/events/cloud/index.vue' /* webpackChunkName: "pages/company/events/cloud/index" */))
const _2c5cd283 = () => interopDefault(import('../pages/company/events/omr/index.vue' /* webpackChunkName: "pages/company/events/omr/index" */))
const _49bbe697 = () => interopDefault(import('../pages/technologie/google-marketing-platform-partner/kontakt/index.vue' /* webpackChunkName: "pages/technologie/google-marketing-platform-partner/kontakt/index" */))
const _6a9d0baa = () => interopDefault(import('../pages/technology/google-marketing-platform-partner/contact/index.vue' /* webpackChunkName: "pages/technology/google-marketing-platform-partner/contact/index" */))
const _41ab8bcd = () => interopDefault(import('../pages/unternehmen/events/analytics-hub/index.vue' /* webpackChunkName: "pages/unternehmen/events/analytics-hub/index" */))
const _c5e44cca = () => interopDefault(import('../pages/unternehmen/events/cdp-event/index.vue' /* webpackChunkName: "pages/unternehmen/events/cdp-event/index" */))
const _37fa1f14 = () => interopDefault(import('../pages/unternehmen/events/cloud/index.vue' /* webpackChunkName: "pages/unternehmen/events/cloud/index" */))
const _1e3c751a = () => interopDefault(import('../pages/unternehmen/events/omr/index.vue' /* webpackChunkName: "pages/unternehmen/events/omr/index" */))
const _7468a1f1 = () => interopDefault(import('../pages/company/events/omr/meeting-request/index.vue' /* webpackChunkName: "pages/company/events/omr/meeting-request/index" */))
const _1d8be2eb = () => interopDefault(import('../pages/unternehmen/events/analytics-hub/online/index.vue' /* webpackChunkName: "pages/unternehmen/events/analytics-hub/online/index" */))
const _09220d19 = () => interopDefault(import('../pages/unternehmen/events/omr/terminanfrage/index.vue' /* webpackChunkName: "pages/unternehmen/events/omr/terminanfrage/index" */))
const _e542f99c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _92e81904 = () => interopDefault(import('../pages/company/events/omr/meeting-request/_year/index.vue' /* webpackChunkName: "pages/company/events/omr/meeting-request/_year/index" */))
const _1dd5de10 = () => interopDefault(import('../pages/unternehmen/events/analytics-hub/online/_year/index.vue' /* webpackChunkName: "pages/unternehmen/events/analytics-hub/online/_year/index" */))
const _c97b3eb4 = () => interopDefault(import('../pages/unternehmen/events/omr/terminanfrage/_year/index.vue' /* webpackChunkName: "pages/unternehmen/events/omr/terminanfrage/_year/index" */))
const _bf1e6070 = () => interopDefault(import('../pages/company/events/omr/meeting-request/_year/_month/index.vue' /* webpackChunkName: "pages/company/events/omr/meeting-request/_year/_month/index" */))
const _2d2c750e = () => interopDefault(import('../pages/unternehmen/events/analytics-hub/online/_year/_month/index.vue' /* webpackChunkName: "pages/unternehmen/events/analytics-hub/online/_year/_month/index" */))
const _3e44c5a0 = () => interopDefault(import('../pages/unternehmen/events/omr/terminanfrage/_year/_month/index.vue' /* webpackChunkName: "pages/unternehmen/events/omr/terminanfrage/_year/_month/index" */))
const _7aec9de2 = () => interopDefault(import('../pages/company/events/analytics-hub/_location/index.vue' /* webpackChunkName: "pages/company/events/analytics-hub/_location/index" */))
const _6ff78a30 = () => interopDefault(import('../pages/company/events/cdp-event/_location/index.vue' /* webpackChunkName: "pages/company/events/cdp-event/_location/index" */))
const _324b1469 = () => interopDefault(import('../pages/company/events/cloud/_location/index.vue' /* webpackChunkName: "pages/company/events/cloud/_location/index" */))
const _bc58d7f0 = () => interopDefault(import('../pages/company/events/omr/_location/index.vue' /* webpackChunkName: "pages/company/events/omr/_location/index" */))
const _3ceab8d2 = () => interopDefault(import('../pages/unternehmen/events/analytics-hub/_location/index.vue' /* webpackChunkName: "pages/unternehmen/events/analytics-hub/_location/index" */))
const _40cec5c0 = () => interopDefault(import('../pages/unternehmen/events/cdp-event/_location/index.vue' /* webpackChunkName: "pages/unternehmen/events/cdp-event/_location/index" */))
const _7069c14e = () => interopDefault(import('../pages/unternehmen/events/cloud/_location/index.vue' /* webpackChunkName: "pages/unternehmen/events/cloud/_location/index" */))
const _58b99af8 = () => interopDefault(import('../pages/unternehmen/events/omr/_location/index.vue' /* webpackChunkName: "pages/unternehmen/events/omr/_location/index" */))
const _17a576af = () => interopDefault(import('../pages/company/events/analytics-hub/_location/_year/index.vue' /* webpackChunkName: "pages/company/events/analytics-hub/_location/_year/index" */))
const _0c151f06 = () => interopDefault(import('../pages/company/events/cdp-event/_location/_year/index.vue' /* webpackChunkName: "pages/company/events/cdp-event/_location/_year/index" */))
const _553cabf6 = () => interopDefault(import('../pages/company/events/cloud/_location/_year/index.vue' /* webpackChunkName: "pages/company/events/cloud/_location/_year/index" */))
const _1128b855 = () => interopDefault(import('../pages/company/events/omr/_location/_year/index.vue' /* webpackChunkName: "pages/company/events/omr/_location/_year/index" */))
const _4600c4c2 = () => interopDefault(import('../pages/unternehmen/events/analytics-hub/_location/_year/index.vue' /* webpackChunkName: "pages/unternehmen/events/analytics-hub/_location/_year/index" */))
const _34d88f6d = () => interopDefault(import('../pages/unternehmen/events/cdp-event/_location/_year/index.vue' /* webpackChunkName: "pages/unternehmen/events/cdp-event/_location/_year/index" */))
const _60e4c2e6 = () => interopDefault(import('../pages/unternehmen/events/cloud/_location/_year/index.vue' /* webpackChunkName: "pages/unternehmen/events/cloud/_location/_year/index" */))
const _fe6c6976 = () => interopDefault(import('../pages/unternehmen/events/omr/_location/_year/index.vue' /* webpackChunkName: "pages/unternehmen/events/omr/_location/_year/index" */))
const _c570f912 = () => interopDefault(import('../pages/company/events/analytics-hub/_location/_year/_month/index.vue' /* webpackChunkName: "pages/company/events/analytics-hub/_location/_year/_month/index" */))
const _2020f42e = () => interopDefault(import('../pages/company/events/cdp-event/_location/_year/_month/index.vue' /* webpackChunkName: "pages/company/events/cdp-event/_location/_year/_month/index" */))
const _b4e3bf60 = () => interopDefault(import('../pages/company/events/cloud/_location/_year/_month/index.vue' /* webpackChunkName: "pages/company/events/cloud/_location/_year/_month/index" */))
const _02cc3b11 = () => interopDefault(import('../pages/company/events/omr/_location/_year/_month/index.vue' /* webpackChunkName: "pages/company/events/omr/_location/_year/_month/index" */))
const _631ea2f2 = () => interopDefault(import('../pages/unternehmen/events/analytics-hub/_location/_year/_month/index.vue' /* webpackChunkName: "pages/unternehmen/events/analytics-hub/_location/_year/_month/index" */))
const _0608b8f9 = () => interopDefault(import('../pages/unternehmen/events/cdp-event/_location/_year/_month/index.vue' /* webpackChunkName: "pages/unternehmen/events/cdp-event/_location/_year/_month/index" */))
const _69db5b60 = () => interopDefault(import('../pages/unternehmen/events/cloud/_location/_year/_month/index.vue' /* webpackChunkName: "pages/unternehmen/events/cloud/_location/_year/_month/index" */))
const _244cfa21 = () => interopDefault(import('../pages/unternehmen/events/omr/_location/_year/_month/index.vue' /* webpackChunkName: "pages/unternehmen/events/omr/_location/_year/_month/index" */))
const _51ca78c4 = () => interopDefault(import('../pages/company/career/_slug/index.vue' /* webpackChunkName: "pages/company/career/_slug/index" */))
const _164605ad = () => interopDefault(import('../pages/company/events/_eventname/index.vue' /* webpackChunkName: "pages/company/events/_eventname/index" */))
const _f9e50700 = () => interopDefault(import('../pages/technologie/google-marketing-platform-partner/_sub/index.vue' /* webpackChunkName: "pages/technologie/google-marketing-platform-partner/_sub/index" */))
const _0a276d4d = () => interopDefault(import('../pages/technology/google-marketing-platform-partner/_sub/index.vue' /* webpackChunkName: "pages/technology/google-marketing-platform-partner/_sub/index" */))
const _34c6e4bd = () => interopDefault(import('../pages/unternehmen/events/_eventname/index.vue' /* webpackChunkName: "pages/unternehmen/events/_eventname/index" */))
const _6df1d416 = () => interopDefault(import('../pages/unternehmen/karriere/_slug/index.vue' /* webpackChunkName: "pages/unternehmen/karriere/_slug/index" */))
const _0cc34a9c = () => interopDefault(import('../pages/company/events/_eventname/_location/index.vue' /* webpackChunkName: "pages/company/events/_eventname/_location/index" */))
const _7e1fa5c2 = () => interopDefault(import('../pages/unternehmen/events/_eventname/_location/index.vue' /* webpackChunkName: "pages/unternehmen/events/_eventname/_location/index" */))
const _1c2a577f = () => interopDefault(import('../pages/company/events/_eventname/_location/_year/index.vue' /* webpackChunkName: "pages/company/events/_eventname/_location/_year/index" */))
const _3dab168f = () => interopDefault(import('../pages/unternehmen/events/_eventname/_location/_year/index.vue' /* webpackChunkName: "pages/unternehmen/events/_eventname/_location/_year/index" */))
const _ab09ceb2 = () => interopDefault(import('../pages/company/events/_eventname/_location/_year/_month/index.vue' /* webpackChunkName: "pages/company/events/_eventname/_location/_year/_month/index" */))
const _57884797 = () => interopDefault(import('../pages/unternehmen/events/_eventname/_location/_year/_month/index.vue' /* webpackChunkName: "pages/unternehmen/events/_eventname/_location/_year/_month/index" */))
const _1155b782 = () => interopDefault(import('../pages/events/_eventname/index.vue' /* webpackChunkName: "pages/events/_eventname/index" */))
const _0d92fa29 = () => interopDefault(import('../pages/insights/_slug/index.vue' /* webpackChunkName: "pages/insights/_slug/index" */))
const _a4f326a8 = () => interopDefault(import('../pages/services/_slug/index.vue' /* webpackChunkName: "pages/services/_slug/index" */))
const _96406c72 = () => interopDefault(import('../pages/technologie/_slug/index.vue' /* webpackChunkName: "pages/technologie/_slug/index" */))
const _2121175a = () => interopDefault(import('../pages/technology/_slug/index.vue' /* webpackChunkName: "pages/technology/_slug/index" */))
const _08ec545f = () => interopDefault(import('../pages/services/_slug/connected-tv/index.vue' /* webpackChunkName: "pages/services/_slug/connected-tv/index" */))
const _af57134c = () => interopDefault(import('../pages/services/_slug/_sub/index.vue' /* webpackChunkName: "pages/services/_slug/_sub/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/company",
    component: _332ef7c0,
    name: "company"
  }, {
    path: "/datenschutz",
    component: _6fd22546,
    name: "datenschutz"
  }, {
    path: "/events",
    component: _9de2a9a8,
    name: "events"
  }, {
    path: "/impressum",
    component: _3e32559a,
    name: "impressum"
  }, {
    path: "/imprint",
    component: _642e84ac,
    name: "imprint"
  }, {
    path: "/insights",
    component: _c0a36d24,
    name: "insights"
  }, {
    path: "/privacy-policy",
    component: _a816e0ac,
    name: "privacy-policy"
  }, {
    path: "/services",
    component: _6482cb9e,
    name: "services"
  }, {
    path: "/technologie",
    component: _9382b0e8,
    name: "technologie"
  }, {
    path: "/technology",
    component: _0aa25f5f,
    name: "technology"
  }, {
    path: "/unternehmen",
    component: _9503f1a0,
    name: "unternehmen"
  }, {
    path: "/company/about-us",
    component: _3969e183,
    name: "company-about-us"
  }, {
    path: "/company/career",
    component: _77538ea3,
    name: "company-career"
  }, {
    path: "/company/contact",
    component: _114aaef1,
    name: "company-contact"
  }, {
    path: "/company/events",
    component: _e7c73b04,
    name: "company-events"
  }, {
    path: "/technologie/google-marketing-platform-partner",
    component: _f040b274,
    name: "technologie-google-marketing-platform-partner"
  }, {
    path: "/technologie/lunio",
    component: _3097a4e8,
    name: "technologie-lunio"
  }, {
    path: "/technologie/meridian",
    component: _5cefa68c,
    name: "technologie-meridian"
  }, {
    path: "/technology/google-marketing-platform-partner",
    component: _8d88ac4e,
    name: "technology-google-marketing-platform-partner"
  }, {
    path: "/technology/lunio",
    component: _c64e1b0a,
    name: "technology-lunio"
  }, {
    path: "/technology/meridian",
    component: _d62adb72,
    name: "technology-meridian"
  }, {
    path: "/unternehmen/events",
    component: _43704d6e,
    name: "unternehmen-events"
  }, {
    path: "/unternehmen/karriere",
    component: _c7b3a38c,
    name: "unternehmen-karriere"
  }, {
    path: "/unternehmen/kontakt",
    component: _07503d01,
    name: "unternehmen-kontakt"
  }, {
    path: "/unternehmen/ueber-uns",
    component: _61b48b8d,
    name: "unternehmen-ueber-uns"
  }, {
    path: "/company/events/analytics-hub",
    component: _ea74f646,
    name: "company-events-analytics-hub"
  }, {
    path: "/company/events/cdp-event",
    component: _0faedaab,
    name: "company-events-cdp-event"
  }, {
    path: "/company/events/cloud",
    component: _fe33afb8,
    name: "company-events-cloud"
  }, {
    path: "/company/events/omr",
    component: _2c5cd283,
    name: "company-events-omr"
  }, {
    path: "/technologie/google-marketing-platform-partner/kontakt",
    component: _49bbe697,
    name: "technologie-google-marketing-platform-partner-kontakt"
  }, {
    path: "/technology/google-marketing-platform-partner/contact",
    component: _6a9d0baa,
    name: "technology-google-marketing-platform-partner-contact"
  }, {
    path: "/unternehmen/events/analytics-hub",
    component: _41ab8bcd,
    name: "unternehmen-events-analytics-hub"
  }, {
    path: "/unternehmen/events/cdp-event",
    component: _c5e44cca,
    name: "unternehmen-events-cdp-event"
  }, {
    path: "/unternehmen/events/cloud",
    component: _37fa1f14,
    name: "unternehmen-events-cloud"
  }, {
    path: "/unternehmen/events/omr",
    component: _1e3c751a,
    name: "unternehmen-events-omr"
  }, {
    path: "/company/events/omr/meeting-request",
    component: _7468a1f1,
    name: "company-events-omr-meeting-request"
  }, {
    path: "/unternehmen/events/analytics-hub/online",
    component: _1d8be2eb,
    name: "unternehmen-events-analytics-hub-online"
  }, {
    path: "/unternehmen/events/omr/terminanfrage",
    component: _09220d19,
    name: "unternehmen-events-omr-terminanfrage"
  }, {
    path: "/",
    component: _e542f99c,
    name: "index"
  }, {
    path: "/company/events/omr/meeting-request/:year",
    component: _92e81904,
    name: "company-events-omr-meeting-request-year"
  }, {
    path: "/unternehmen/events/analytics-hub/online/:year",
    component: _1dd5de10,
    name: "unternehmen-events-analytics-hub-online-year"
  }, {
    path: "/unternehmen/events/omr/terminanfrage/:year",
    component: _c97b3eb4,
    name: "unternehmen-events-omr-terminanfrage-year"
  }, {
    path: "/company/events/omr/meeting-request/:year?/:month",
    component: _bf1e6070,
    name: "company-events-omr-meeting-request-year-month"
  }, {
    path: "/unternehmen/events/analytics-hub/online/:year/:month",
    component: _2d2c750e,
    name: "unternehmen-events-analytics-hub-online-year-month"
  }, {
    path: "/unternehmen/events/omr/terminanfrage/:year/:month",
    component: _3e44c5a0,
    name: "unternehmen-events-omr-terminanfrage-year-month"
  }, {
    path: "/company/events/analytics-hub/:location",
    component: _7aec9de2,
    name: "company-events-analytics-hub-location"
  }, {
    path: "/company/events/cdp-event/:location",
    component: _6ff78a30,
    name: "company-events-cdp-event-location"
  }, {
    path: "/company/events/cloud/:location",
    component: _324b1469,
    name: "company-events-cloud-location"
  }, {
    path: "/company/events/omr/:location",
    component: _bc58d7f0,
    name: "company-events-omr-location"
  }, {
    path: "/unternehmen/events/analytics-hub/:location",
    component: _3ceab8d2,
    name: "unternehmen-events-analytics-hub-location"
  }, {
    path: "/unternehmen/events/cdp-event/:location",
    component: _40cec5c0,
    name: "unternehmen-events-cdp-event-location"
  }, {
    path: "/unternehmen/events/cloud/:location",
    component: _7069c14e,
    name: "unternehmen-events-cloud-location"
  }, {
    path: "/unternehmen/events/omr/:location",
    component: _58b99af8,
    name: "unternehmen-events-omr-location"
  }, {
    path: "/company/events/analytics-hub/:location?/:year",
    component: _17a576af,
    name: "company-events-analytics-hub-location-year"
  }, {
    path: "/company/events/cdp-event/:location?/:year",
    component: _0c151f06,
    name: "company-events-cdp-event-location-year"
  }, {
    path: "/company/events/cloud/:location/:year",
    component: _553cabf6,
    name: "company-events-cloud-location-year"
  }, {
    path: "/company/events/omr/:location/:year",
    component: _1128b855,
    name: "company-events-omr-location-year"
  }, {
    path: "/unternehmen/events/analytics-hub/:location?/:year",
    component: _4600c4c2,
    name: "unternehmen-events-analytics-hub-location-year"
  }, {
    path: "/unternehmen/events/cdp-event/:location?/:year",
    component: _34d88f6d,
    name: "unternehmen-events-cdp-event-location-year"
  }, {
    path: "/unternehmen/events/cloud/:location/:year",
    component: _60e4c2e6,
    name: "unternehmen-events-cloud-location-year"
  }, {
    path: "/unternehmen/events/omr/:location/:year",
    component: _fe6c6976,
    name: "unternehmen-events-omr-location-year"
  }, {
    path: "/company/events/analytics-hub/:location?/:year/:month",
    component: _c570f912,
    name: "company-events-analytics-hub-location-year-month"
  }, {
    path: "/company/events/cdp-event/:location?/:year/:month",
    component: _2020f42e,
    name: "company-events-cdp-event-location-year-month"
  }, {
    path: "/company/events/cloud/:location/:year/:month",
    component: _b4e3bf60,
    name: "company-events-cloud-location-year-month"
  }, {
    path: "/company/events/omr/:location/:year/:month",
    component: _02cc3b11,
    name: "company-events-omr-location-year-month"
  }, {
    path: "/unternehmen/events/analytics-hub/:location?/:year/:month",
    component: _631ea2f2,
    name: "unternehmen-events-analytics-hub-location-year-month"
  }, {
    path: "/unternehmen/events/cdp-event/:location?/:year/:month",
    component: _0608b8f9,
    name: "unternehmen-events-cdp-event-location-year-month"
  }, {
    path: "/unternehmen/events/cloud/:location/:year/:month",
    component: _69db5b60,
    name: "unternehmen-events-cloud-location-year-month"
  }, {
    path: "/unternehmen/events/omr/:location/:year/:month",
    component: _244cfa21,
    name: "unternehmen-events-omr-location-year-month"
  }, {
    path: "/company/career/:slug",
    component: _51ca78c4,
    name: "company-career-slug"
  }, {
    path: "/company/events/:eventname",
    component: _164605ad,
    name: "company-events-eventname"
  }, {
    path: "/technologie/google-marketing-platform-partner/:sub",
    component: _f9e50700,
    name: "technologie-google-marketing-platform-partner-sub"
  }, {
    path: "/technology/google-marketing-platform-partner/:sub",
    component: _0a276d4d,
    name: "technology-google-marketing-platform-partner-sub"
  }, {
    path: "/unternehmen/events/:eventname",
    component: _34c6e4bd,
    name: "unternehmen-events-eventname"
  }, {
    path: "/unternehmen/karriere/:slug",
    component: _6df1d416,
    name: "unternehmen-karriere-slug"
  }, {
    path: "/company/events/:eventname/:location",
    component: _0cc34a9c,
    name: "company-events-eventname-location"
  }, {
    path: "/unternehmen/events/:eventname/:location",
    component: _7e1fa5c2,
    name: "unternehmen-events-eventname-location"
  }, {
    path: "/company/events/:eventname/:location/:year",
    component: _1c2a577f,
    name: "company-events-eventname-location-year"
  }, {
    path: "/unternehmen/events/:eventname/:location/:year",
    component: _3dab168f,
    name: "unternehmen-events-eventname-location-year"
  }, {
    path: "/company/events/:eventname/:location/:year/:month",
    component: _ab09ceb2,
    name: "company-events-eventname-location-year-month"
  }, {
    path: "/unternehmen/events/:eventname/:location/:year/:month",
    component: _57884797,
    name: "unternehmen-events-eventname-location-year-month"
  }, {
    path: "/events/:eventname",
    component: _1155b782,
    name: "events-eventname"
  }, {
    path: "/insights/:slug",
    component: _0d92fa29,
    name: "insights-slug"
  }, {
    path: "/services/:slug",
    component: _a4f326a8,
    name: "services-slug"
  }, {
    path: "/technologie/:slug",
    component: _96406c72,
    name: "technologie-slug"
  }, {
    path: "/technology/:slug",
    component: _2121175a,
    name: "technology-slug"
  }, {
    path: "/services/:slug/connected-tv",
    component: _08ec545f,
    name: "services-slug-connected-tv"
  }, {
    path: "/services/:slug/:sub",
    component: _af57134c,
    name: "services-slug-sub"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
